import { globalState } from '@codeleap/store'
import { navigate } from 'gatsby'

const locationPathState = globalState({ pathname: null })

const registerCurrentPath = () => {
  locationPathState.set({ pathname: location.pathname })
}

const returnToPath = () => {
  let returned = false

  const storedPath = locationPathState.get()
  const { pathname } = storedPath

  if (pathname) {
    returned = true
    locationPathState.set({ pathname: null })
    navigate(pathname as never)
  }

  return returned
}

export const locationPath = {
  registerCurrentPath,
  returnToPath
}
